"use client"

import type React from "react"
import { ArdacityHeaderBW } from "@ar-dacity/ardacity-headerbw"
import { ArdacityBentoBW } from "@ar-dacity/ardacity-bentobw"
import { ArdacityFooterBW } from "@ar-dacity/ardacity-footerbw"

export interface ArdacityLandingPageOneProps {
  onConnectWallet?: () => Promise<void>
  onDisconnectWallet?: () => Promise<void>
  walletAddress?: string
  isConnecting?: boolean
}

export const ArdacityLandingPageOne: React.FC<ArdacityLandingPageOneProps> = ({
  onConnectWallet,
  onDisconnectWallet,
  walletAddress = "",
  isConnecting = false,
}) => {
  return (
    <div className="min-h-screen bg-white text-black flex flex-col">
      <ArdacityHeaderBW
        title="Ardacity"
        walletAddress={walletAddress}
        isConnecting={isConnecting}
        onConnectWallet={onConnectWallet}
        onDisconnectWallet={onDisconnectWallet}
      />

      <main className="flex-1">
        {/* Hero Section */}
        <section className="py-20 border-b border-gray-200">
          <div className="container mx-auto px-4 max-w-6xl">
            <div className="flex flex-col md:flex-row items-center justify-between gap-12">
              <div className="md:w-1/2">
                <h1 className="text-5xl font-bold mb-6">
                  <span className="text-gray-500">The Fitness</span> Journey
                  <br />
                  Starts Here
                </h1>
                <p className="text-gray-600 mb-8 text-lg">
                  Welcome to Ardacity UI, where your fitness goals meet decentralized technology. Track, manage, and
                  achieve your fitness milestones with blockchain security.
                </p>
                <button
                  className="bg-black hover:bg-gray-800 text-white font-bold py-3 px-8 rounded-md transition duration-300"
                  onClick={onConnectWallet}
                >
                  {walletAddress ? "View Dashboard" : "Connect Wallet"}
                </button>
              </div>
              <div className="md:w-1/2">
                <div className="relative">
                  <div className="bg-gray-100 rounded-2xl p-6 shadow-lg">
                    <div className="text-sm text-gray-500 mb-2">Progress</div>
                    <div className="flex items-center gap-3 mb-6">
                      <div className="h-16 w-4 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-[60%] w-full bg-black rounded-full"></div>
                      </div>
                      <div className="h-16 w-4 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-[80%] w-full bg-black rounded-full"></div>
                      </div>
                      <div className="h-16 w-4 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-[40%] w-full bg-black rounded-full"></div>
                      </div>
                      <div className="h-16 w-4 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-[70%] w-full bg-black rounded-full"></div>
                      </div>
                      <div className="h-16 w-4 bg-gray-200 rounded-full overflow-hidden">
                        <div className="h-[90%] w-full bg-black rounded-full"></div>
                      </div>
                    </div>
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="text-sm text-gray-500">Daily Goal</div>
                        <div className="text-xl font-bold">1,500 kcal</div>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">Completed</div>
                        <div className="text-xl font-bold">1,100 kcal</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Bento Grid Section */}
        <ArdacityBentoBW />
      </main>

      <ArdacityFooterBW />
    </div>
  )
}

export default ArdacityLandingPageOne
